import React from "react";
// nodejs library that concatenates classes
// import classNames from "classnames";
// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";

import officeStyle from "assets/jss/material-kit-pro-react/views/aboutUsSections/officeStyle.jsx";

import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
// import Button from "components/CustomButtons/Button.jsx";
// import Tooltip from "@material-ui/core/Tooltip";
// @material-ui/icons
import FormatAlignLeft from "@material-ui/icons/FormatAlignLeft";

// office

import description from "assets/img/bg.jpg";

function SectionOffice(props) {
  const { classes } = props;
  return (
    <div className={classes.office}>

      <GridContainer>

        <GridItem xs={12} sm={12} md={12}>
          <Card
            raised
            background
            style={{ backgroundImage: "url(" + description + ")" }}
          >
            <CardBody background>
              <h6 className={classes.category}>Services and Markets</h6>

                <h3 className={classes.cardTitle}>
                  We offer comprehensive advice designed for each client according to the needs of each project
                </h3>
              
              <p className={classes.category}>
                Agency services,
                Capital Markets,
                Consultancy,
                Corporate Finance and Debt,
                Planning,
                Property Management,
                Research,
                Tenant Representation,
                Valuation and appraisal
              </p>

            </CardBody>
          </Card>
        </GridItem>




      </GridContainer>
    </div>
  );
}

export default withStyles(officeStyle)(SectionOffice);
